import { Portal } from 'react-portal';
import { CheckmarkIcon, CloseIcon } from '../../../assets/icons';
import { useState } from 'react';

type ToggleStatusProps = {
  label: string;
};

const ToggleStatus = ({ label }: ToggleStatusProps): JSX.Element => (
  <div className="core-feature-toggle-status__status-container">
    <CheckmarkIcon className="core-feature-toggle-status__enabled-icon" />
    <p className="core-feature-toggle-status__status-text">{label}</p>
  </div>
);
export const FeatureToggleStatus = (): JSX.Element => {
  const [isOpen, setIsOpen] = useState(true);

  const buttonAlt = 'Close feature toggle status bar';

  const isAnyFeatureOn = null;

  if (!isAnyFeatureOn || !isOpen) return <></>;

  return (
    <Portal node={document && document.getElementById('feature-toggle-status-root')}>
      <div className="core-feature-toggle-status__container">
        <div className="core-feature-toggle-status__pill">
          <button
            type="button"
            aria-label={buttonAlt}
            title={buttonAlt}
            onClick={() => setIsOpen(false)}
            className="core-feature-toggle-status__close-button"
          >
            <CloseIcon />
          </button>
        </div>
      </div>
    </Portal>
  );
};
